import React from "react";
export default class PromiseComponent extends React.Component {
  setStateAsync = (state) => {
    return new Promise((resolve, reject) => {
      return this.setState(state, resolve);
    });
  }
}
